import { render } from "./MergeHeader.vue?vue&type=template&id=f953dd2c"
import script from "./MergeHeader.vue?vue&type=script&lang=ts"
export * from "./MergeHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script